
import HeaderContentController from './header-content.controller';

function headerContent(){
    return {
        restrict: "E",
        scope: {
            name: '=',
            id: "=",
            chartIndex: '='
        },
        template: require('./header-content.html'),
        controller: HeaderContentController,
        controllerAs: 'ctrl'
    }
}

export default angular
    .module('header-content.directive', [])
    .directive('headerContent', headerContent)
    .name;


// WEBPACK FOOTER //
// ./src/app/views/header-content/header-content.directive.js